import moment from 'moment-timezone';
import noop from 'lodash/noop';
import difference from 'lodash/difference';
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';

// Actions
const FETCH_TWITTER_IMPORTS = 'admin/FETCH_TWITTER_IMPORTS';
const FETCH_TWITTER_IMPORTS_SUCCEEDED = 'admin/FETCH_TWITTER_IMPORTS_SUCCEEDED';
const FETCH_TWITTER_IMPORTS_FAILED = 'admin/FETCH_TWITTER_IMPORTS_FAILED';
const UPDATE_TWITTER_JOB_STATUS_CHANGED = 'admin/UPDATE_TWITTER_JOB_STATUS_CHANGED';
const UPDATE_TWITTER_JOB_STATUS_CHANGED_SUCCEEDED = 'admin/UPDATE_TWITTER_JOB_STATUS_CHANGED_SUCCEEDED';
const UPDATE_TWITTER_JOB_STATUS_CHANGED_FAILED = 'admin/UPDATE_TWITTER_JOB_STATUS_CHANGED_FAILED';
const UPDATE_TWITTER_CLEAN_ERROR_MESSAGE = 'UPDATE_TWITTER_CLEAN_ERROR_MESSAGE';

const NEW_TWITTER_IMPORT_INIT = 'admin/NEW_TWITTER_IMPORT_INIT';
const NEW_TWITTER_IMPORT_CAMPAIGN_SELECTION = 'admin/NEW_TWITTER_IMPORT_CAMPAIGN_SELECTION';
const NEW_TWITTER_IMPORT_FETCH_PROFILES_SUCCEEDED = 'admin/NEW_TWITTER_IMPORT_FETCH_PROFILES_SUCCEEDED';
const NEW_TWITTER_IMPORT_FETCH_PROFILES_FAILED = 'admin/NEW_TWITTER_IMPORT_FETCH_PROFILES_FAILED';
const NEW_TWITTER_IMPORT_PROFILE_SELECTION = 'admin/NEW_TWITTER_IMPORT_PROFILE_SELECTION';
const NEW_TWITTER_IMPORT_DATE_RANGE_SELECTION = 'admin/NEW_TWITTER_IMPORT_DATE_RANGE_SELECTION';
const NEW_TWITTER_IMPORT_SUBMIT = 'admin/NEW_TWITTER_IMPORT_SUBMIT';
const NEW_TWITTER_IMPORT_SUBMIT_SUCCEEDED = 'admin/NEW_TWITTER_IMPORT_SUBMIT_SUCCEEDED';
const NEW_TWITTER_IMPORT_SUBMIT_FAILED = 'admin/NEW_TWITTER_IMPORT_SUBMIT_FAILED';
const NEW_TWITTER_IMPORT_CLOSE_BANNER = 'admin/NEW_TWITTER_IMPORT_CLOSE_BANNER';
const NEW_TWITTER_IMPORT_CLOSE_MODAL = 'admin/NEW_TWITTER_IMPORT_CLOSE_MODAL';

const newImportInitialState = {
  // new twitter import
  profiles: [],
  selectedCampaign: [],
  // selectedProfiles: {},
  // startDate: null,
  // endDate: null,
  jobType: 'estimate',
  saving: false,
  showBanner: false,
  bannerTitle: '',
  bannerText: '',
  bannerType: '',
  // estimate: null
};

const initialState = {
  twitterImports: [],
  fetchTwitterImportsError: null,
  updateTwitterJobChangeError: null,
  limit: 10,
  offset: 0,
  total: 0,
  isFetching: false,
  selectedFilters: ['all']
};

let _newElementAdded = noop;

// Reducer
// eslint-disable-next-line complexity
const reducer = (state = Object.assign({}, initialState, newImportInitialState), action = {}) => {
  const { type, payload } = action;

  switch (type) {
    case FETCH_TWITTER_IMPORTS: {
      const { selectedFilters } = payload;
      const extraProperties = {
        isFetching: true
      };
      if (!isEqual(selectedFilters.sort(), state.selectedFilters.sort())) {
        extraProperties.twitterImports = [];
        extraProperties.offset = 0;
        extraProperties.limit = 10;
        extraProperties.total = 0;
      }
      return { ...state, ...newImportInitialState, ...extraProperties };
    }
    case FETCH_TWITTER_IMPORTS_SUCCEEDED: {
      const { limit, offset, total } = state;
      const twitterImports = state.twitterImports.concat(payload);
      const nextOffset = offset + limit;
      return {
        ...state,
        isFetching: false,
        twitterImports,
        limit,
        offset: nextOffset,
        total,
        fetchTwitterImportsError: null,
      };
    }
    case FETCH_TWITTER_IMPORTS_FAILED:
      return { ...state, isFetching: false, fetchTwitterImportsError: payload };
    case NEW_TWITTER_IMPORT_INIT: {
      const { accountId, campaignId, profilesDefault } = payload;
      return {
        ...state,
        ...initialState,
        accountId,
        selectedCampaign: [campaignId],
        profiles: [profilesDefault]
      };
    }
    case NEW_TWITTER_IMPORT_CAMPAIGN_SELECTION:{
      const _removedCampaign = difference(state.selectedCampaign, payload.map((e)=> e.value));
      const _selectedProfiles = cloneDeep(state.selectedProfiles) || {};
      if(_removedCampaign){
        _removedCampaign.forEach((e)=> delete _selectedProfiles[e]);
      }

      return {
        ...state,
        selectedCampaign: payload.map((e)=> e.value),
        profiles: [],
        selectedProfiles: _selectedProfiles,
        isFetching: true
      };
    }
    case NEW_TWITTER_IMPORT_FETCH_PROFILES_SUCCEEDED:
      return { ...state, profiles: payload.map((e) => e.profiles), isFetching: false };
    case NEW_TWITTER_IMPORT_FETCH_PROFILES_FAILED:
      return { ...state, isFetching: false };
    case NEW_TWITTER_IMPORT_PROFILE_SELECTION: {
      const _selectedProfiles = {...state.selectedProfiles};
      _selectedProfiles[payload.campaignId] = payload.profiles;
      return { ...state, selectedProfiles: _selectedProfiles};
    }
    case NEW_TWITTER_IMPORT_DATE_RANGE_SELECTION: {
      const { startDate, endDate } = payload;
      let _endDate = endDate;
      if (_endDate === 'now' || _endDate === null) {
        _endDate = moment.tz().subtract(30, 'minutes').format('YYYY-MM-DD+HH:mm:ss');
      }
      return { ...state, startDate, endDate: _endDate };
    }
    case NEW_TWITTER_IMPORT_SUBMIT:
      return { ...state, jobType: state.estimate ? 'import' : 'estimate', saving: true };
    case NEW_TWITTER_IMPORT_SUBMIT_SUCCEEDED:
      return {
        ...state,
        ...newImportInitialState,
        selectedCampaign: state.selectedCampaign,
        profiles: state.profiles,
        showBanner: false,
        bannerTitle: 'TWITTER Import Created.',
        bannerText: 'The new TWITTER Import was successfully created.',
        bannerType: 'success',
        estimate: payload ? payload.estimate : null
      };
    case NEW_TWITTER_IMPORT_SUBMIT_FAILED:
      return {
        ...state,
        saving: false,
        showBanner: true,
        bannerTitle: 'Create TWITTER Import Error',
        bannerText: payload,
        bannerType: 'error',
      };
    case NEW_TWITTER_IMPORT_CLOSE_MODAL:
      return {
        ...state,
        estimate: null,
        hasEstimate: false
      };
    case NEW_TWITTER_IMPORT_CLOSE_BANNER:
      return { ...state,
        showBanner: false
      };
    case UPDATE_TWITTER_JOB_STATUS_CHANGED:
      return {
        ...state,
        estimate: null,
        isFetching: true
      };
    case UPDATE_TWITTER_JOB_STATUS_CHANGED_SUCCEEDED: {
      const updatedTwitterImportsList = state.twitterImports.map((element) => {
        if (element.jobURL === action.payload.jobURL) {
          element.status = action.payload.status;
          element.jobType = action.payload.jobType;
        }
        return element;
      });
      return { ...state,
        isFetching: false,
        twitterImports: updatedTwitterImportsList
      };
    }
    case UPDATE_TWITTER_JOB_STATUS_CHANGED_FAILED:
      return { ...state,
        isFetching: false,
        updateTwitterJobChangeError: action.payload
      };
    case UPDATE_TWITTER_CLEAN_ERROR_MESSAGE:
      return { ...state,
        isFetching: false,
        updateTwitterJobChangeError: null
      };
    default: return state;
  }
};

// Action Creators
const fetchTwitterImports = (selectedFilters) => {
  return { type: FETCH_TWITTER_IMPORTS, payload: { selectedFilters }  };
};

const fetchTwitterImportsSucceeded = (payload) => {
  return { type: FETCH_TWITTER_IMPORTS_SUCCEEDED, payload };
};

const fetchTwitterImportsFailed = (payload) => {
  return { type: FETCH_TWITTER_IMPORTS_FAILED, payload };
};

const fetchProfilesSucceeded = (payload) => {
  return { type: NEW_TWITTER_IMPORT_FETCH_PROFILES_SUCCEEDED, payload };
};

const fetchProfilesFailed = (payload) => {
  return { type: NEW_TWITTER_IMPORT_FETCH_PROFILES_FAILED, payload };
};

const handleCampaignChange = (payload) => {
  return { type: NEW_TWITTER_IMPORT_CAMPAIGN_SELECTION, payload };
};

const handleProfilesChange = (payload) => {
  return { type: NEW_TWITTER_IMPORT_PROFILE_SELECTION, payload };
};

const handleDateRangeChange = (payload) => {
  return { type: NEW_TWITTER_IMPORT_DATE_RANGE_SELECTION, payload };
};

const handleSubmit = () => {
  return { type: NEW_TWITTER_IMPORT_SUBMIT };
};

const handleSubmitSucceeded = (payload) => {
  _newElementAdded();
  return { type: NEW_TWITTER_IMPORT_SUBMIT_SUCCEEDED, payload };
};

const handleSubmitFailed = (payload) => {
  return { type: NEW_TWITTER_IMPORT_SUBMIT_FAILED, payload };
};

const newImportInit = (accountId, campaignId, profilesDefault) => {
  return { type: NEW_TWITTER_IMPORT_INIT, payload: { accountId, campaignId, profilesDefault } };
};

const handleCloseBanner = () => {
  return { type: NEW_TWITTER_IMPORT_CLOSE_BANNER };
};

const updateTwitterChangeStatus = (payload) => {
  return { type: UPDATE_TWITTER_JOB_STATUS_CHANGED, payload };
};

const updateTwitterChangeStatusSucceeded = (payload) => {
  return { type: UPDATE_TWITTER_JOB_STATUS_CHANGED_SUCCEEDED, payload };
};

const updateTwitterChangeStatusFailed = (payload) => {
  return { type: UPDATE_TWITTER_JOB_STATUS_CHANGED_FAILED, payload };
};

const updateTwitterCleanErrorStatusMessage = () => {
  return { type: UPDATE_TWITTER_CLEAN_ERROR_MESSAGE };
};

const handleTwitterModalClosed = () => {
  return { type: NEW_TWITTER_IMPORT_CLOSE_MODAL };
};

const newElementAdded = (onNewElementAdded) => {
  _newElementAdded =  onNewElementAdded;
};

const createTwitterImport = () => {
  return { type: NEW_TWITTER_IMPORT_SUBMIT };
};

export default reducer;
export {
  // Actions
  FETCH_TWITTER_IMPORTS,
  FETCH_TWITTER_IMPORTS_SUCCEEDED,
  FETCH_TWITTER_IMPORTS_FAILED,
  // Action Creators
  fetchTwitterImports,
  fetchTwitterImportsSucceeded,
  fetchTwitterImportsFailed,
  fetchProfilesSucceeded,
  fetchProfilesFailed,
  // Actions new imports
  NEW_TWITTER_IMPORT_INIT,
  NEW_TWITTER_IMPORT_CAMPAIGN_SELECTION,
  NEW_TWITTER_IMPORT_FETCH_PROFILES_SUCCEEDED,
  NEW_TWITTER_IMPORT_FETCH_PROFILES_FAILED,
  NEW_TWITTER_IMPORT_PROFILE_SELECTION,
  NEW_TWITTER_IMPORT_DATE_RANGE_SELECTION,
  NEW_TWITTER_IMPORT_SUBMIT,
  NEW_TWITTER_IMPORT_SUBMIT_SUCCEEDED,
  NEW_TWITTER_IMPORT_SUBMIT_FAILED,
  NEW_TWITTER_IMPORT_CLOSE_BANNER,
  NEW_TWITTER_IMPORT_CLOSE_MODAL,
  UPDATE_TWITTER_JOB_STATUS_CHANGED,
  UPDATE_TWITTER_JOB_STATUS_CHANGED_SUCCEEDED,
  UPDATE_TWITTER_JOB_STATUS_CHANGED_FAILED,
  UPDATE_TWITTER_CLEAN_ERROR_MESSAGE,
  // Action Creators new imports
  handleCampaignChange,
  handleProfilesChange,
  handleDateRangeChange,
  handleSubmit,
  handleSubmitSucceeded,
  handleSubmitFailed,
  newImportInit,
  handleCloseBanner,
  handleTwitterModalClosed,
  updateTwitterChangeStatus,
  updateTwitterChangeStatusSucceeded,
  updateTwitterChangeStatusFailed,
  updateTwitterCleanErrorStatusMessage,
  newElementAdded,
  createTwitterImport
};
